import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { SimpleSelectProps, SimpleSelect } from '@agro-club/frontend-shared'
import { LifeCycleChangeReason } from 'types/entities'

const LifeCycleChangeReasonSelect: React.FC<Omit<SimpleSelectProps, 'options'>> = ({ ...selectProps }) => {
  const { t } = useTranslation('contactLifeCycle')
  const options = useMemo(() => {
    return Object.keys(LifeCycleChangeReason).map((e) => {
      return { id: LifeCycleChangeReason[e], title: LifeCycleChangeReason[e] }
    })
  }, [t])

  return <SimpleSelect {...selectProps} options={options} isClearable />
}

export default LifeCycleChangeReasonSelect
